import { FulfillmentDTO } from '@invenco/common-interface/sales';

import { Card } from '@/components-ant/card';

import { Fulfillment } from './Fulfillment';
import { FulfillmentsContainer } from './styles';
import { useOrderFulfillmentsComponent } from './useOrderFulfillmentsComponent';

type Props = {
  loading?: boolean;
  fulfillments?: FulfillmentDTO[];
};

export function OrderFulfillments({ loading, fulfillments = [] }: Props) {
  const {
    models: { shipmentsByFulfillmentId, shipDateByFulfillmentId },
  } = useOrderFulfillmentsComponent({ fulfillments });
  return (
    <Card title="Fulfillments" count={loading ? undefined : fulfillments.length}>
      <FulfillmentsContainer>
        {fulfillments.map((f) => (
          <Fulfillment
            key={f.id}
            fulfillment={f}
            shipments={shipmentsByFulfillmentId[f.id] ?? []}
            shipDate={shipDateByFulfillmentId[f.id]}
          />
        ))}
      </FulfillmentsContainer>
    </Card>
  );
}
